export default "__VITE_ASSET__pz9qXS2T__"